import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useOpenedStore } from '../db/context';

const bar = 'flex items-center gap-3 border-b border-border px-4 py-2 text-sm';

export function StorageBanner() {
  const { t } = useTranslation();
  const { persistent, reason } = useOpenedStore();
  const [hidden, setHidden] = useState(false);
  if (persistent || hidden) return null;
  return (
    <div
      role="alert"
      className={`${bar} bg-amber-100 text-amber-950 dark:bg-amber-950 dark:text-amber-100`}
    >
      <span className="flex-1">{t('app.notPersistent', { reason: reason ?? 'OPFS' })}</span>
      <button type="button" className="underline" onClick={() => setHidden(true)}>
        {t('app.dismiss')}
      </button>
    </div>
  );
}

/** Service-worker lifecycle (web only; the desktop build has no service worker). */
export function PwaBanner() {
  const { t } = useTranslation();
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  if (!offlineReady && !needRefresh) return null;
  return (
    <div role="status" className={`${bar} bg-bg-subtle`}>
      <span className="flex-1">
        {needRefresh ? t('app.updateAvailable') : t('app.offlineReady')}
      </span>
      {needRefresh && (
        <button
          type="button"
          className="font-medium text-accent-ink"
          onClick={() => {
            void updateServiceWorker(true);
            // The service worker normally reloads the page itself once it takes
            // control; in a private/incognito window (restricted storage, as
            // flagged by StorageBanner) that handoff can silently never happen.
            setTimeout(() => window.location.reload(), 1500);
          }}
        >
          {t('app.reload')}
        </button>
      )}
      <button
        type="button"
        className="underline"
        onClick={() => {
          setOfflineReady(false);
          setNeedRefresh(false);
        }}
      >
        {t('app.dismiss')}
      </button>
    </div>
  );
}
